import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  fileNameTitle: {
    id: 'frontend-app-ora.FileContent.fileNameTitle',
    defaultMessage: 'File name',
    description: ' title for file name',
  },
  fileDescriptionTitle: {
    id: 'frontend-app-ora.FileCellContent.fileDescriptionTitle',
    defaultMessage: 'File description',
    description: ' title for file description',
  },
  fileSizeTitle: {
    id: 'frontend-app-ora.FileCellContent.fileSizeTitle',
    defaultMessage: 'File size',
    description: ' title for file size',
  },
  fileUploadTitle: {
    id: 'frontend-app-ora.FileCellContent.fileUploadTitle',
    defaultMessage: 'File upload',
    description: ' title for file upload',
  },
  fileActionsTitle: {
    id: 'frontend-app-ora.FileCellContent.fileActionsTitle',
    defaultMessage: 'Actions',
    description: ' title for file actions',
  },
  deleteButtonAltText: {
    id: 'frontend-app-ora.FileCellContent.deleteButtonAltText',
    defaultMessage: 'Delete',
    description: ' alt text for delete button',
  },
  previewButtonAltText: {
    id: 'frontend-app-ora.FileCellContent.previewButtonAltText',
    defaultMessage: 'Preview',
    description: ' alt text for preview button',
  },
  uploadFileModalTitle: {
    id: 'frontend-app-ora.FileCellContent.uploadFileModalTitle',
    defaultMessage: 'Add a text description to your file',
    description: 'Ask user to add a text description to the file',
  },
  uploadFileDescriptionFieldLabel: {
    id: 'frontend-app-ora.FileCellContent.uploadFileDescriptionFieldLabel',
    defaultMessage: 'Description for: ',
    description: 'Label for file description field',
  },
  uploadedFilesTitle: {
    id: 'frontend-app-ora.FileCellContent.uploadedFilesTitle',
    defaultMessage: 'Uploaded files',
    description: 'Title for uploaded files',
  },
  cancelUploadFileButton: {
    id: 'frontend-app-ora.FileCellContent.cancelUploadFileButton',
    defaultMessage: 'Cancel upload',
    description: 'Label for cancel button',
  },
  confirmUploadFileButton: {
    id: 'frontend-app-ora.FileCellContent.confirmUploadFileButton',
    defaultMessage: 'Upload files',
    description: 'Label for upload button',
  },
  fileDescriptionMissingError: {
    id: 'frontend-app-ora.FileCellContent.fileDescriptionMissingError',
    defaultMessage: 'Please enter a file description',
    description: 'Error message when file description is missing',
  },
  downloadFiles: {
    id: 'frontend-app-ora.ResponseDisplay.SubmissionFiles.downloadFiles',
    defaultMessage: 'Download files',
    description: 'Download files inactive state label',
  },
  downloading: {
    id: 'frontend-app-ora.ResponseDisplay.SubmissionFiles.downloading',
    defaultMessage: 'Downloading',
    description: 'Download files pending state label',
  },
  downloaded: {
    id: 'frontend-app-ora.ResponseDisplay.SubmissionFiles.downloaded',
    defaultMessage: 'Downloaded!',
    description: 'Download files completed state label',
  },
  retryDownload: {
    id: 'frontend-app-ora.ResponseDisplay.SubmissionFiles.retryDownload',
    defaultMessage: 'Retry download',
    description: 'Download files failed state label',
  },
  filePopoverNameTitle: {
    id: 'frontend-app-ora.FilePopoverContent.filePopoverNameTitle',
    defaultMessage: 'File name',
    description: 'Popover title for file name',
  },
  filePopoverDescriptionTitle: {
    id: 'frontend-app-ora.FilePopoverCellContent.filePopoverDescriptionTitle',
    defaultMessage: 'File description',
    description: 'Popover title for file description',
  },
  required: {
    id: 'frontend-app-ora.FileUpload.required',
    defaultMessage: 'File Upload is required',
    description: 'Indicating file upload is required',
  },
});

export default messages;
